import { createFileRoute } from '@tanstack/react-router';

import { PreviredPage } from '@/features/previred/components/previred-page';

export const Route = createFileRoute('/_app/remuneraciones/previred')({
  component: PreviredPage,
});
